var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage"
  }, [_c('assessment-helper'), _c('div', {
    staticClass: "mat-man-match"
  }, [_vm.showImage ? _c('div', {
    staticClass: "drag-completed"
  }, [_c('span', {
    staticClass: "image-header"
  }, [_vm._v(_vm._s(_vm.currentRound.shape))]), _c('img', {
    staticClass: "completed-image",
    attrs: {
      "alt": "",
      "src": _vm.currentRound.completed
    }
  })]) : _vm._e(), !_vm.showImage ? _c('div', {
    staticClass: "drag-panel"
  }, [_c('div', {
    staticClass: "drag-container"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "dragging-area",
      "src": _vm.currentRound.empty
    }
  })]), _c('div', {
    staticClass: "draggable-items",
    class: {
      isMobile: _vm.isMobile
    }
  }, _vm._l(_vm.currentRound.draggableShapes, function (draggableShape, index) {
    return _c('div', {
      key: index,
      staticClass: "draggable-item"
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "selected-image",
      attrs: {
        "alt": "",
        "id": draggableShape.id,
        "src": draggableShape.selected
      }
    }), _c('img', {
      staticClass: "unselected-image",
      attrs: {
        "alt": "",
        "src": draggableShape.unselected
      }
    })]), _c('div', {
      staticClass: "image-text"
    }, [_vm._v(_vm._s(draggableShape.shape))])]);
  }), 0)]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }